import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

export type CreateIdentityProviderRequestResponse = {
    response: IdentityProviderChangeRequestResponse
};

export const createIdentityProviderRequest = async (
    sourceIdentityProviderID: string,
    identityProviderConfiguration: { [key: string]: any }
): Promise<{ data: CreateIdentityProviderRequestResponse, error: any }> => {
    const route = apiRoutes.idpConfiguration.identityProviderConfig.changeRequest.identityProvider.add;

    let body;
    if (sourceIdentityProviderID) {
        body = {
            sourceIdentityProviderID: sourceIdentityProviderID
        }
    } else if (identityProviderConfiguration) {
        body = identityProviderConfiguration;
    }

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error };
};